var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 0H15.5V10H0.5V0ZM1.5 1V9H14.5V1H1.5Z","fill":"black","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 0L8 6.5L15.5 0H0.5ZM3.18073 1L8 5.1767L12.8193 1H3.18073Z","fill":"black","key":1})]);
}

Email.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = Email;

Email.default = Email;
